
import { GAME_ALLOWED_PROJECTS } from 'assets/configurations/envConfigs';
import { SONGS } from 'assets/configurations/songs';
import { INSTRUMENTS } from 'assets/configurations/instruments';


const [DEFAULT_MODE] = GAME_ALLOWED_PROJECTS;


export function generateLobbyId(projectId = DEFAULT_MODE.id) {
    return `${projectId}${Math.floor(Math.random() * 90000) + 10000}`;
};

export function matchProject(projectId = DEFAULT_MODE.id) {
    return GAME_ALLOWED_PROJECTS.find(({ id }) => id === projectId) || DEFAULT_MODE;
};

export function getSongBySlug(slug = '') {
    for(let s of SONGS) {
        if(s.slug === slug) return s;
    }

    return { title: '', slug: '', thumb: { path: '' }};
}

export function getInstrumentBySlug(slug = '') {
    for(let i of INSTRUMENTS) {
        if(i.slug === slug) return i;
    }

    return { title: '', slug: ''};
}

export function isMobile() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

export function isLandscape() {
    return isMobile() && ((screen.orientation && screen.orientation.type.includes("landscape")) || window.innerWidth > window.innerHeight);
}